module.exports = __webpack_public_path__ + "static/Testimonial1-b7e356d8537d8c6443018d2313568ad3.jpg";